<!-- Loading -->
<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header compact-header">
  <div class="container-fluid">

    <div class="header-row">

      <a href="javascript:void(0)" (click)="goBack()" class="back-btn">
        <i class="fa fa-arrow-left"></i>
      </a>

      <h5 class="page-title mb-0">
        Update Spare Parts
      </h5>

      <a routerLink="/" class="home-btn">
        <i class="fas fa-home"></i>
      </a>

    </div>

  </div>
</section>
<!-- /.content-header -->
<section class="content">
  <div class="container-fluid">

    <div class="card shadow-sm rounded-lg">

      <!-- Header -->
      <div class="card-header">
        <h5 class="mb-0 text-danger font-weight-bold">
          {{vehicle?.data?.make}} {{vehicle?.data?.model}}
        </h5>
      </div>

      <div class="card-body">

        <!-- Alerts -->
        <div class="alert alert-danger" *ngIf="errorMessage">
          {{errorMessage}}
        </div>

        <div class="alert alert-success" *ngIf="successMessage">
          {{successMessage}}
        </div>

        <!-- Details -->
        <div class="vehicle-details row">
          <!-- LEFT COLUMN -->
          <div class="col-6">
            <div class="detail-item">
                <strong>Chassis No.</strong>&nbsp;
                {{vehicle.data.chassis_no}}
            </div>

            <div class="detail-item">
                <strong>Engine CC</strong>&nbsp;
                {{vehicle.data.engine_cc}}
            </div>

            <div class="detail-item">
                <strong>Transmission</strong>&nbsp;
                {{vehicle.data.transmission}}
            </div>

            <div class="detail-item">
                <strong>Body Type</strong>&nbsp;
                {{vehicle.data.body_type}}
            </div>
          </div>
          <!-- RIGHT COLUMN -->
          <div class="col-6">
            <div class="detail-item">
              <strong>Fuel</strong>&nbsp;
                {{vehicle.data.fuel}}
            </div>

            <div class="detail-item">
                <strong>Colour</strong>&nbsp;
                {{vehicle.data.colour}}
            </div>

            <div class="detail-item">
                <strong>Year</strong>&nbsp;
                {{vehicle.data.year}}
            </div>

            <div class="detail-item">
                <strong>Mileage</strong>&nbsp;
                {{vehicle.data.mileage}}
            </div>
          </div>
      </div>
      <div class="col-12">

        <h6 class="spare-title text-danger font-weight-bold">
          Available Spare Parts
        </h6>

        <!-- Search -->
        <div class="row mb-2">
          <div class="col-12">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text bg-white border-success">
                  <i class="fas fa-search"></i>
                </span>
              </div>

              <input
                type="text"
                class="form-control border-success"
                placeholder="Search"
                (input)="onSearchTextChange($event)"
              />
            </div>
          </div>
        </div>

        <!-- Scrollable Spare Parts -->
        <div class="spare-parts-scroll">
          <table class="table table-bordered table-hover mb-0">
            <thead>
              <tr>
                <th width="60"></th>
                <th>Part Name</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let part of spare_parts | searchSparePart: searchText">
                <td>
                  <input
                    type="checkbox"
                    [(ngModel)]="part.checked"
                    (change)="checkboxChange($event, part)"
                    class="form-control"
                  />
                </td>

                <td>{{ part.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        </div>

        <!-- Action Buttons -->
        <div class="release-btn-wrapper mt-3">
          <button class="btn btn-success rounded-pill release-btn" (click)="confirmAvailableSpareParts()">
            <i class="fas fa-arrow-alt-circle-right"></i>
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Confirm Transfer Modal -->
<div
  class="modal fade"
  #confirmAvailableSparePartsModal
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered mobile-transfer-modal">
    <div class="modal-content">

      <div class="modal-body">

        <!-- Title -->
        <h3 class="modal-title">Confirm Available Spare Parts</h3>

        <!-- Spare Parts -->
        <div class="parts-list">
          <div *ngFor="let part of selectedSpareParts">
            {{ part.name }}
          </div>
        </div>

        <!-- Buttons -->
        <div class="modal-actions">
          <button
            class="btn modal-btn cancel-btn"
            data-dismiss="modal"
          >
            Cancel
          </button>

          <button type="submit" class="btn modal-btn ok-btn" (click)="updateSpareParts()">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
